/** Lediga platser: delade konstanter (inga serverberoenden). */
export const VACANCY_DAYS = 30;
export const VACANCY_REMIND_DAY = 25;

/** "28 september 2026" i svensk tid. */
export function formatDate(iso: string): string {
  try {
    return new Intl.DateTimeFormat("sv-SE", {
      day: "numeric",
      month: "long",
      year: "numeric",
      timeZone: "Europe/Stockholm",
    }).format(new Date(iso));
  } catch {
    return iso.slice(0, 10);
  }
}
